import { render, staticRenderFns } from "./AccessControlManager.vue?vue&type=template&id=47fe2910&scoped=true"
import script from "./AccessControlManager.vue?vue&type=script&lang=js"
export * from "./AccessControlManager.vue?vue&type=script&lang=js"
import style0 from "./AccessControlManager.vue?vue&type=style&index=0&id=47fe2910&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fe2910",
  null
  
)

export default component.exports